import React, { Component } from 'react'
import { Container } from 'reactstrap'
import DataWrapper from '../../principal/containers/DataWrapper'
import { inject, observer } from 'mobx-react'
import FiltroAcomp from '../components/FiltroAcomp'
import AcompanhamentoStore from '../stores/AcompanhamentoStore'
import InfoAcomp from '../components/InfoAcomp';
import ModalForm from '../../comum/components/ModalForm'
import { IconeCarregar } from '../../comum/components/Icones'
import ModalAviso from '../../comum/components/ModalAviso'
import ModalAverbacao from '../components/ModalAverbacao'
import ModalArquivos from '../components/ModalArquivos'
import ModalVesselVisit from '../components/ModalVesselVisit'
import FiltrosAcompMobile from '../components/FiltrosAcompMobile'
import Footer from '../../comum/components/Footer'
import FooterOptions from '../../comum/components/FooterOptions'
import IconButton from '../../comum/components/IconButton'

@inject("store")
@DataWrapper
@observer
export class Acompanhamento extends Component {

    constructor(props) {
        super(props)

        this.tituloPaginaStore = this.props.store.tituloPaginaStore

        this.controller = new AcompanhamentoStore()

        this.handleDesistencia = this.handleDesistencia.bind(this)
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Acompanhamento de Processo");
        this.props.store.appStore.showVoltarTopBar(false, '/');
    }

    handleDesistencia() {
        this.controller.desistirVistoria();
        this.controller.fecharDesistencia();
    }

    modalAverbacao = () => {
        
        if (this.controller.listaProcessos.length === 0 && this.controller.showModalAverbacao){ 
            this.controller.listarProcessos();
        }
        if (this.controller.listaDespachanteUsuario.length === 0 && this.controller.showModalAverbacao){
         this.controller.listarDespachantePorUsuario();
        }

        return this.controller.showModalAverbacao && <ModalAverbacao controller={this.controller} />;
    }

    modalArquivos = () =>{
        return  (
            this.controller.showModalArquivos && <ModalArquivos controller={this.controller} />
        );
    }

    modalMensagemAverbacaoStatus = () => {
        return (
            this.controller.mensagemModalAverbacao != "" &&
            <ModalAviso onClickFechar={() => this.controller.mensagemModalAverbacao = ""}>
                <h2>{this.controller.mensagemModalAverbacao}</h2>
                <h4>{this.controller.mensagemErroAverbacao}</h4>
            </ModalAviso>
        );
    }

    modalMensagemAverbacaoBLValido = () => {       
        return (
            this.controller.mensagemModalBLValido &&
            <ModalAviso onClickFechar={() => this.controller.mensagemModalBLValido = ""}>
                <h2>Houve um problema ao salvar a averbação</h2>
                <span>{this.controller.mensagemModalBLValido}</span>
            </ModalAviso>
        );       
    }

    modalDesistencia() {
        return this.controller.showModalDesistencia &&
            <ModalForm
                className="tamanho-modal-acomproc"
                labelConfirmar="SIM"
                labelCancelar="NÃO"
                onClickSalvar={this.handleDesistencia}
                onClickCancelar={() => this.controller.fecharDesistencia()}
            >
                <h2>Você realmente deseja desistir da vistoria de lacre?</h2>
                {!process.env.rig
                    ? <p className="text-desistencia">Presença de carga enviada sem a conferência física da carga.
                    Caso o importador prefira aguardar a conferência física para avaliar a integridade da carga,
                antes do registro da DI, deverá programar a desova e conferência junto ao {!process.env.rig ? "Atendimento ao Cliente" : "GAC"}.</p>
                    : <p className="text-desistencia">O Importador acima mencionado, através de seu representante abaixo assinado,
                        DESISTE da vistoria dos volumes acima citados, assumindo inteira responsabilidade pelo ônus
                        decorrente desta desistência e DECLARA concordar que após a retirada da carga das dependências do TECON RIO GRANDE S/A,
                        o referido terminal está isento de qualquer responsabilidade sobre o conteúdo da carga, razão pela qual, em nenhuma hipótese
                    poderá ser responsabilizado por qualquer custo e/ou dano direto ou indireto.</p>
                }
            </ModalForm>
    }

    modalMensagemDesistencia(){
        return this.controller.desistenciaMensagem !== "" && <ModalAviso
            onClickFechar={() => this.controller.desistenciaMensagem = ""}
        >
            <h2>
                {this.controller.desistenciaMensagem}
            </h2>
        </ModalAviso>
    }

    renderInfo = () => {
        const infoData = this.controller.atualizaDados ? <InfoAcomp controller={this.controller} /> : <div /> 
        if (this.controller.mensagemErro !== "") {
            return <span className="mensagem-filtrar">{this.controller.mensagemErro}</span>
        } else if (this.controller.carregando) {
            return <IconeCarregar tamanho="2x" />
        } else if (this.controller.mostrarInfo) {
            return infoData
        } else {
            return null
        }
    }
    
    modalVesselVisit() {
        return this.controller.showModalVesselVisit &&
            <ModalVesselVisit controller={this.controller} />
    }

    render() {
        return (
            <div className="form-wrapper">
                {this.modalDesistencia()}
                {this.modalMensagemDesistencia()}
                {this.modalAverbacao()}
                {this.modalArquivos()}
                {this.modalMensagemAverbacaoStatus()}
                {this.modalMensagemAverbacaoBLValido()}
                {this.modalVesselVisit()}
                <Container fluid>
                    {
                        window.innerWidth < 991
                        ? <FiltrosAcompMobile controller={this.controller} />
                        : <FiltroAcomp controller={this.controller} />

                    }
                    {this.renderInfo()}
                </Container>
                <Footer>
                    <FooterOptions>
                        <IconButton
                            icon="file-pdf"
                            text="Baixar PDF"
                            size="md"
                            disabled={this.controller.dadosProcesso === null}
                            onClick={this.controller.baixarRelatorioDetalhado}
                        />
                    </FooterOptions>
                </Footer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/telas/Acompanhamento.js